import React, { memo } from "react";

/**
 * Renderiza o componente SearchPrincipalFilter.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {*} props.origem - Propriedade `origem` do componente.
 * @param {*} props.setFilters - Propriedade `setFilters` do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const SearchPrincipalFilter = memo((props) => {
  const { origem, setFilters } = props;

  return <div>FILTER</div>;
});

export default SearchPrincipalFilter;
